export default __webpack_public_path__ + "static/media/Политика_в_отношении_обработки_ПД.b5e43465.pdf";